import axios from 'axios';
import { normalizeProfileUserId } from '../utils/profileRoutes';
import { normalizePresenceStatus } from '../utils/presenceStatus';
import { resolveGatewayBackedServiceBaseUrl } from './serviceBaseUrl';

const CHAT_SERVICE_URL = resolveGatewayBackedServiceBaseUrl(process.env.REACT_APP_CHAT_SERVICE_URL);

export const fetchPresenceStatuses = async (userIds) => {
    if (!Array.isArray(userIds) || userIds.length === 0) {
        return [];
    }

    const normalizedIds = [...new Set(
        userIds
            .map((id) => normalizeProfileUserId(id))
            .filter(Boolean)
    )];

    if (normalizedIds.length === 0) {
        return [];
    }

    const searchParams = new URLSearchParams();
    normalizedIds.forEach((id) => searchParams.append('userIds', id));

    try {
        const response = await axios.get(
            `${CHAT_SERVICE_URL}/api/chat/presence?${searchParams.toString()}`,
            { withCredentials: true }
        );
        const statuses = Array.isArray(response.data?.statuses)
            ? response.data.statuses
            : [];
        return statuses
            .map((status) => normalizePresenceStatus(status, { requireEpoch: true }))
            .filter(Boolean);
    } catch (error) {
        console.error('Failed to fetch presence statuses', error);
        return [];
    }
};
